import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  LOT_RECEIVED: {
    id: "inventory.audit.eventType.LOT_RECEIVED",
    defaultMessage: "Inventory Received",
  },
  LOT_UPDATED: {
    id: "inventory.audit.eventType.LOT_UPDATED",
    defaultMessage: "Inventory Updated",
  },
  PRESCRIPTION_DISPENSED: {
    id: "inventory.audit.eventType.PRESCRIPTION_DISPENSED",
    defaultMessage: "Prescription Dispensed",
  },
  STOCK_TAKE_START: {
    id: "inventory.audit.eventType.STOCK_STAKE_START",
    defaultMessage: "Start Stocktake",
  },
  STOCK_TAKE_FINALISE: {
    id: "inventory.audit.eventType.STOCK_TAKE_FINALISE",
    defaultMessage: "Complete Stocktake",
  },
  MOVE_REQUEST_FULFILLED: {
    id: "inventory.audit.eventType.MOVE_REQUEST_FULFILLED",
    defaultMessage: "Fulfill Move Request",
  },
  STOCK_MOVED_FROM: {
    id: "inventory.audit.eventType.STOCK_MOVED_FROM",
    defaultMessage: "Moved From",
  },
  STOCK_MOVED_TO: {
    id: "inventory.audit.eventType.STOCK_MOVED_TO",
    defaultMessage: "Moved To",
  },
});

export function useAuditEventTypeMapping() {
  const { formatMessage } = useIntl();

  return (eventType: string) =>
    messages[eventType] ? formatMessage(messages[eventType]) : eventType;
}
